import { addMilestoneOnce, getState } from './storage';
import { getGameStats } from './adaptive';
import { WORLDS, worldGames } from '../content/games';

// "First time" moments, for parents only. A 2-year-old cannot read these —
// their purpose is to let a parent witness learning they did not see happen.
// Aggregate stats make a parent nod; a specific moment makes them feel something.

export const MILESTONE = {
  FIRST_GAME: 'first_game',
  FIRST_WORLD: 'first_world',
  FIRST_PERFECT: 'first_perfect',
  FIRST_SKILL: 'first_skill',
};

// Called once per completed game, after recordGameResult has been written.
// Returns the milestones newly unlocked by this play (usually none).
export function detectMilestones({ gameId, worldId, skill, rounds, attempts }) {
  const earned = [];
  const push = (m) => { if (m) earned.push(m); };

  push(addMilestoneOnce(`${MILESTONE.FIRST_GAME}:${gameId}`, {
    type: MILESTONE.FIRST_GAME, gameId, worldId, skill,
  }));

  // No wrong taps at all: one attempt per round.
  if (typeof attempts === 'number' && typeof rounds === 'number' && rounds > 0 && attempts <= rounds) {
    push(addMilestoneOnce(`${MILESTONE.FIRST_PERFECT}:${gameId}`, {
      type: MILESTONE.FIRST_PERFECT, gameId, worldId, skill,
    }));
  }

  if (skill) {
    push(addMilestoneOnce(`${MILESTONE.FIRST_SKILL}:${skill}`, {
      type: MILESTONE.FIRST_SKILL, skill, gameId, worldId,
    }));
  }

  // A world counts as finished when every active game in it is completed.
  if (worldId && WORLDS[worldId]) {
    const ids = worldGames(worldId);
    if (ids.length && ids.every((id) => getGameStats(id)?.completed)) {
      push(addMilestoneOnce(`${MILESTONE.FIRST_WORLD}:${worldId}`, {
        type: MILESTONE.FIRST_WORLD, worldId,
      }));
    }
  }

  return earned;
}

// Milestones from the last `days` days, newest first.
export function recentMilestones(days = 7) {
  const cutoff = Date.now() - days * 86400000;
  return (getState().milestones || []).filter((m) => {
    const t = new Date(m.date).getTime();
    return !Number.isNaN(t) && t >= cutoff;
  });
}
